import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface CreditInfoBannerProps {
  message?: string;
  /** Show warning when credit limit is exceeded */
  exceedsCreditLimit?: boolean;
  /** Maximum credit amount for warning message */
  maxCreditAmount?: number;
}

const STYLES = {
  background: '#ffebee',
  borderRadius: '8px',
  iconColor: '#d32f2f',
  textColor: '#c62828',
  px: 2,
  py: 1.5,
  mt: 2,
};

const WARNING_STYLES = {
  background: '#fff3e0',
  iconColor: '#ed6c02',
  textColor: '#e65100',
};

const DEFAULT_MESSAGE = 'Invoice will save as credit';

const CreditInfoBanner: React.FC<CreditInfoBannerProps> = ({
  message = DEFAULT_MESSAGE,
  exceedsCreditLimit = false,
  maxCreditAmount,
}) => {
  return (
    <Box>
      <Box
        role="alert"
        aria-live="polite"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          backgroundColor: STYLES.background,
          borderRadius: STYLES.borderRadius,
          px: STYLES.px,
          py: STYLES.py,
          mt: STYLES.mt,
        }}
      >
        <InfoOutlinedIcon sx={{ color: STYLES.iconColor, fontSize: 20 }} aria-hidden="true" />
        <Typography variant="body2" sx={{ color: STYLES.textColor }}>
          {message}
        </Typography>
      </Box>
      
      {exceedsCreditLimit && (
        <Box
          role="alert"
          aria-live="polite"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: WARNING_STYLES.background,
            borderRadius: STYLES.borderRadius,
            px: STYLES.px,
            py: STYLES.py,
            mt: 1,
          }}
        >
          <WarningAmberIcon sx={{ color: WARNING_STYLES.iconColor, fontSize: 20 }} aria-hidden="true" />
          <Typography variant="body2" sx={{ color: WARNING_STYLES.textColor }}>
            Net amount exceeds maximum credit limit{maxCreditAmount !== undefined ? ` (${maxCreditAmount.toLocaleString()})` : ''}. Please review before saving.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CreditInfoBanner;